import { LOGO_DARK, LOGO_LIGHT, THEME } from "@constants/global";
import ToggleLang from "components/ToggleLang/ToggleLang";
import ToggleTheme from "components/ToggleTheme/ToggleTheme";
import { useTheme } from "next-themes";
import useTranslation from "next-translate/useTranslation";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import { useState } from "react";
import toast from "react-hot-toast";

import dynamic from "next/dynamic";

import ReCAPTCHA from "react-google-recaptcha";

import { PUBLIC_ROUTES } from "routes/routes";
import { Input, InputGroup } from "rsuite";
import { Button } from "components/ui/v2";
const CrispWithNoSSR = dynamic(() => import("../../../../Crisp/Crisp"));

export default function VendorSelectorClassic() {
  const { t, lang } = useTranslation("common");
  const { theme } = useTheme();
  const [domain, setDomain] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [reRouting, setReRouting] = useState<boolean>(false);
  const router = useRouter();
  const [loading, setLoading] = useState<boolean>(false);
  const [captcha, setCaptcha] = useState<string | null>(null);

  const handleCheckDomain = async () => {
    setError("");
    setLoading(true);

    try {
      const response = await fetch("/api/validateVendorName", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: domain,
          captcha,
        }),
      });

      if (!response.ok) {
        throw new Error("Error al buscar el dominio");
      }

      const responseData = await response.json();
      const validateVendorName = responseData;

      if (!validateVendorName) {
        setError(t("El dominio no existe"));
        setLoading(false);
      } else {
        setReRouting(true);
        setLoading(false);
        const hostname = window.location.hostname;
        const parts = hostname.split(".");
        const host = parts.slice(-2).join(".");

        // * get http or https
        const protocol = window.location.protocol;

        window.location.href = `${protocol}//${domain}.${host}`;
      }
    } catch (error) {
      console.error("Error en handleVendorSelect:", error);
      toast.error(t("Error al buscar el dominio"));
      setLoading(false);
    }
  };

  const handleCaptcha = (data: string) => {
    if (data) {
      setCaptcha(data);
    } else {
      setCaptcha(data);
    }
  };

  return (
    <div className="relative flex h-full w-full flex-col items-center justify-center align-middle">
      <CrispWithNoSSR />
      <div className="absolute right-2 top-2 flex items-center gap-2 align-middle">
        <ToggleLang />
        <ToggleTheme />
      </div>
      <div className="flex w-full flex-col gap-2 rounded-lg bg-gray-50 p-10 dark:bg-gray-900 md:w-2/3">
        <div>
          <Image
            src={theme === THEME.dark ? LOGO_DARK : LOGO_LIGHT}
            width={250}
            height={50}
            alt="GroowCity Logo"
          />
        </div>
        <span className="text-left">
          {t("Ingrese el dominio de la empresa")}
        </span>
        <div className="flex flex-col gap-2 md:flex-row">
          <div className="w-full md:w-2/3">
            <InputGroup>
              <Input
                placeholder={t("ej: groowcity-x")}
                value={domain}
                onChange={setDomain}
              />
              <InputGroup.Addon>.groowcity.com</InputGroup.Addon>
            </InputGroup>
            {error && <small className="text-red-500">{error}</small>}
          </div>
          <Button
            variant="primary"
            block
            size="lg"
            className="w-full md:w-1/3"
            disabled={loading || domain.length < 1 || !captcha}
            onClick={handleCheckDomain}
            loading={loading || reRouting}
          >
            {t("Continuar")}
          </Button>
        </div>

        <div className="flex items-center justify-center gap-2">
          <ReCAPTCHA
            sitekey="6Ldu9p4UAAAAANobJCf3Weyt5ptMNMsk9OlYaZoh"
            className="mt-2"
            hl={lang}
            onChange={handleCaptcha}
          />
        </div>
      </div>
      {/* no tienes cuenta organización, crea la tuya */}
      <span className="py-4 text-xs">
        {t("¿No tienes cuenta?")}{" "}
        <a
          className="primary ml-1 self-center font-bold"
          style={{ cursor: "pointer" }}
          onClick={() =>
            router.push({
              pathname: PUBLIC_ROUTES.newOrganization.path,
            })
          }
          aria-hidden
          rel="noreferrer"
        >
          {t("Crea la tuya")}
        </a>
      </span>

      <span className="absolute bottom-2 pb-6 text-xs text-slate-500 dark:text-zinc-400">
        {t("Hecho con")} <span className="text-red-500">❤</span> {t("por")}{" "}
        <a
          href="https://groowcity.com"
          target="_blank"
          className="text-blue-500"
          rel="noreferrer"
        >
          Groowcity
        </a>
      </span>
    </div>
  );
}
